unit UTaetForm;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, UMainConfig,
  Vcl.Imaging.pngimage, Vcl.Controls, WEBLib.ExtCtrls, Types, Vcl.Grids,
  WEBLib.Grids, UTaetList, UTaetModel;

type
  TTaetForm = class(TForm)
    pnlHeader: TPanel;
    imgLogo: TImageControl;
    lblHeader: TLabel;
    btnBack: TImageControl;
    pnlFooter: TPanel;
    pnlFind: TPanel;
    imgFind: TImageControl;
    edtFind: TEdit;
    pnlTaetList: TPanel;
    sgTaetList: TStringGrid;
    procedure btnBackClick(Sender: TObject);
    procedure WebFormResize(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure edtFindChange(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure sgTaetListClickCell(Sender: TObject; ACol, ARow: Integer);
    procedure WebFormOrientationChange(Sender: TObject;
      AOrientation: TScreenOrientation);
  private
    FMainConfig: TMainConfig;
    FTaetList: TTaetList;
    FSelectedTaet: TTaetModel;
    FHideTaet: TTaetModel;
    procedure HandleError(Sender: TObject; AMsg: string);
    procedure HideTaetExecute;
    procedure SgTaetListFill(Sender: TObject);
    procedure SetMainConfig(const Value: TMainConfig);
    procedure SetTaetList(const Value: TTaetList);
    procedure SetSelectedTaet(const Value: TTaetModel);
    procedure SetHideTaet(const Value: TTaetModel);
  public
    property MainConfig: TMainConfig read FMainConfig write SetMainConfig;
    property TaetList: TTaetList read FTaetList write SetTaetList;
    property SelectedTaet: TTaetModel read FSelectedTaet write SetSelectedTaet;
    property HideTaet: TTaetModel read FHideTaet write SetHideTaet;
  protected procedure LoadDFMValues; override; end;

var
  TaetForm: TTaetForm;

implementation

uses
  UEssentialHelper, Math;

{$R *.dfm}
{ TTaetForm }

procedure TTaetForm.btnBackClick(Sender: TObject);
begin
  Self.Close;
end;

procedure TTaetForm.edtFindChange(Sender: TObject);
begin
  Self.TaetList.GetAll(Self.MainConfig.Uri, 0, edtFind.Text);
end;

procedure TTaetForm.HandleError(Sender: TObject; AMsg: string);
begin
  MessageDLG(AMsg, mtError, [mbOK], nil);
end;

procedure TTaetForm.HideTaetExecute;
var
  i: Integer;
  found: Boolean;
begin
  if Self.HideTaet <> nil then
  begin
    i := Self.TaetList.Count - 1;
    found := false;
    while not found and (i >= 0) do
      if Self.TaetList.Items[i].Id = Self.HideTaet.Id then
        found := true
      else
        Dec(i);
    if found then
      Self.TaetList.Delete(i);
  end;
end;

procedure TTaetForm.SetTaetList(const Value: TTaetList);
begin
  FTaetList := Value;
end;

procedure TTaetForm.SetHideTaet(const Value: TTaetModel);
begin
  FHideTaet := Value;
end;

procedure TTaetForm.SetMainConfig(const Value: TMainConfig);
begin
  FMainConfig := Value;
  Self.MainConfig.CurrentForm := Self.Name;
  ColorComponents(Self, Self.MainConfig.ColorConfig);
  pnlFooter.Caption := Self.MainConfig.Copyright;
  Self.TaetList.GetAll(Self.MainConfig.Uri, 0, edtFind.Text);
  Self.WebFormResize(Self);
end;

procedure TTaetForm.SetSelectedTaet(const Value: TTaetModel);
begin
  FSelectedTaet := Value;
end;

procedure TTaetForm.sgTaetListClickCell(Sender: TObject; ACol, ARow: Integer);
begin
  if (0 < ARow) and (ARow <= Self.TaetList.Count) then
    Self.SelectedTaet := Self.TaetList.Items[ARow - 1];
  Self.Close;
end;

procedure TTaetForm.SgTaetListFill(Sender: TObject);
var
  i: Integer;
begin
  if Sender is TTaetList then
    Self.TaetList := Sender as TTaetList;
  Self.HideTaetExecute;
  sgTaetList.DefaultRowHeight := 32;
  sgTaetList.ColCount := 2;
  sgTaetList.RowCount := Self.TaetList.Count + 1;
  sgTaetList.FixedCols := 0;
  sgTaetList.FixedRows := 1;
  sgTaetList.ColWidths[0] := 5;
  sgTaetList.ColWidths[1] := 450;
  sgTaetList.Cells[1, 0] := Bold('Tätigkeiten');
  for i := 0 to Self.TaetList.Count - 1 do
    sgTaetList.Cells[1, i + 1] := Self.TaetList.Items[i].ToString;
end;

procedure TTaetForm.WebFormCreate(Sender: TObject);
begin
  Self.HideTaet := nil;
  edtFind.Text := '';
  Self.TaetList := TTaetList.Create;
  Self.TaetList.OnPropertyChanged := Self.SgTaetListFill;
  Self.TaetList.OnError := Self.HandleError;
end;

procedure TTaetForm.WebFormOrientationChange(Sender: TObject;
  AOrientation: TScreenOrientation);
begin
  Self.WebFormResize(Sender);
end;

procedure TTaetForm.WebFormResize(Sender: TObject);
var
  d: Integer;
begin
  if (Self.Height < 480) or (Self.Width < 640) then
  begin
    btnBack.Width := 24;
    btnBack.Height := 24;
    btnBack.Top := 4;
    btnBack.Left := 4;
    lblHeader.Font.Size := 10;
    lblHeader.Top := 7;
    imgLogo.Width := 74;
    imgLogo.Height := 24;
    imgLogo.Top := 4;
    pnlHeader.Height := 32;
    pnlFooter.Visible := false;
    lblHeader.Caption := 'Tätigkeiten';
    pnlFind.Top := pnlHeader.Top + pnlHeader.Height;
    pnlTaetList.Top := pnlFind.Top + pnlFind.Height;
    pnlTaetList.Height := Self.ClientHeight - pnlHeader.Height - pnlFind.Height;
  end
  else
  begin
    btnBack.Width := 48;
    btnBack.Height := 48;
    btnBack.Top := 8;
    btnBack.Left := 8;
    lblHeader.Font.Size := 16;
    lblHeader.Top := 16;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.Top := 8;
    pnlHeader.Height := 64;
    pnlFooter.Visible := true;
    lblHeader.Caption := 'Winzeit - WebPortal - Tätigkeiten';
    pnlFind.Top := pnlHeader.Top + pnlHeader.Height;
    pnlTaetList.Top := pnlFind.Top + pnlFind.Height;
    pnlTaetList.Height := Self.ClientHeight - pnlHeader.Height - pnlFind.Height
      - pnlFooter.Height;
  end;
  pnlHeader.Width := Self.ClientWidth;
  pnlFooter.Width := pnlHeader.Width;
  lblHeader.Left := 64;
  lblHeader.Width := pnlHeader.ClientWidth - imgLogo.Width - 32;
  imgLogo.Left := pnlHeader.ClientWidth - imgLogo.Width - 16;
  pnlFind.Width := Min(535, Self.ClientWidth);
  pnlTaetList.Width := pnlFind.Width;
  d := (Self.ClientWidth - pnlFind.Width) div 2;
  if d < 0 then
    d := 0;
  pnlFind.Left := d;
  edtFind.Left := imgFind.Left + imgFind.Width + 8;
  edtFind.Width := pnlFind.ClientWidth - imgFind.Width - 24;
  pnlTaetList.Left := pnlFind.Left;
end;

procedure TTaetForm.WebFormShow(Sender: TObject);
begin
  Self.SelectedTaet := nil;
end;

procedure TTaetForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlHeader := TPanel.Create(Self);
  imgLogo := TImageControl.Create(Self);
  lblHeader := TLabel.Create(Self);
  btnBack := TImageControl.Create(Self);
  pnlFooter := TPanel.Create(Self);
  pnlFind := TPanel.Create(Self);
  imgFind := TImageControl.Create(Self);
  edtFind := TEdit.Create(Self);
  pnlTaetList := TPanel.Create(Self);
  sgTaetList := TStringGrid.Create(Self);

  pnlHeader.BeforeLoadDFMValues;
  imgLogo.BeforeLoadDFMValues;
  lblHeader.BeforeLoadDFMValues;
  btnBack.BeforeLoadDFMValues;
  pnlFooter.BeforeLoadDFMValues;
  pnlFind.BeforeLoadDFMValues;
  imgFind.BeforeLoadDFMValues;
  edtFind.BeforeLoadDFMValues;
  pnlTaetList.BeforeLoadDFMValues;
  sgTaetList.BeforeLoadDFMValues;
  try
    Name := 'TaetForm';
    Width := 640;
    Height := 480;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnOrientationChange', 'WebFormOrientationChange');
    SetEvent(Self, 'OnResize', 'WebFormResize');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    pnlHeader.SetParentComponent(Self);
    pnlHeader.Name := 'pnlHeader';
    pnlHeader.Left := 0;
    pnlHeader.Top := 0;
    pnlHeader.Width := 640;
    pnlHeader.Height := 64;
    pnlHeader.Align := alTop;
    pnlHeader.Caption := 'pnlHeader';
    pnlHeader.ChildOrder := 4;
    pnlHeader.Color := clSkyBlue;
    pnlHeader.ShowCaption := False;
    imgLogo.SetParentComponent(pnlHeader);
    imgLogo.Name := 'imgLogo';
    imgLogo.Left := 480;
    imgLogo.Top := 8;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.HeightPercent := 100.000000000000000000;
    imgLogo.WidthPercent := 100.000000000000000000;
    imgLogo.Picture.LoadFromFile('UTaetForm.pnlHeader.imgLogo.Picture.png');
    lblHeader.SetParentComponent(pnlHeader);
    lblHeader.Name := 'lblHeader';
    lblHeader.Left := 64;
    lblHeader.Top := 16;
    lblHeader.Width := 410;
    lblHeader.Height := 30;
    lblHeader.Alignment := taCenter;
    lblHeader.AutoSize := False;
    lblHeader.Caption := 'Winzeit - WebPortal - T'#228'tigkeiten';
    lblHeader.Font.Charset := DEFAULT_CHARSET;
    lblHeader.Font.Color := clWindowText;
    lblHeader.Font.Height := -21;
    lblHeader.Font.Name := 'Segoe UI';
    lblHeader.Font.Style := [fsBold];
    lblHeader.HeightPercent := 100.000000000000000000;
    lblHeader.ParentFont := False;
    lblHeader.WidthPercent := 100.000000000000000000;
    btnBack.SetParentComponent(pnlHeader);
    btnBack.Name := 'btnBack';
    btnBack.Left := 16;
    btnBack.Top := 16;
    btnBack.Width := 32;
    btnBack.Height := 32;
    btnBack.HeightPercent := 100.000000000000000000;
    btnBack.WidthPercent := 100.000000000000000000;
    btnBack.ChildOrder := 2;
    SetEvent(btnBack, Self, 'OnClick', 'btnBackClick');
    btnBack.Picture.LoadFromFile('UTaetForm.pnlHeader.btnBack.Picture.png');
    pnlFooter.SetParentComponent(Self);
    pnlFooter.Name := 'pnlFooter';
    pnlFooter.Left := 0;
    pnlFooter.Top := 456;
    pnlFooter.Width := 640;
    pnlFooter.Height := 24;
    pnlFooter.Align := alBottom;
    pnlFooter.Alignment := taLeftJustify;
    pnlFooter.Caption := 'pnlFooter';
    pnlFooter.ChildOrder := 1;
    pnlFooter.Color := clSkyBlue;
    pnlFind.SetParentComponent(Self);
    pnlFind.Name := 'pnlFind';
    pnlFind.Left := 0;
    pnlFind.Top := 64;
    pnlFind.Width := 640;
    pnlFind.Height := 48;
    pnlFind.Caption := 'pnlFind';
    pnlFind.ChildOrder := 2;
    pnlFind.ShowCaption := False;
    imgFind.SetParentComponent(pnlFind);
    imgFind.Name := 'imgFind';
    imgFind.Left := 4;
    imgFind.Top := 4;
    imgFind.Width := 40;
    imgFind.Height := 40;
    imgFind.HeightPercent := 100.000000000000000000;
    imgFind.WidthPercent := 100.000000000000000000;
    imgFind.URL := 'Images\IconLupe.png';
    edtFind.SetParentComponent(pnlFind);
    edtFind.Name := 'edtFind';
    edtFind.Left := 48;
    edtFind.Top := 13;
    edtFind.Width := 121;
    edtFind.Height := 22;
    edtFind.ChildOrder := 1;
    edtFind.HeightPercent := 100.000000000000000000;
    edtFind.Text := 'edtFind';
    edtFind.WidthPercent := 100.000000000000000000;
    SetEvent(edtFind, Self, 'OnChange', 'edtFindChange');
    pnlTaetList.SetParentComponent(Self);
    pnlTaetList.Name := 'pnlTaetList';
    pnlTaetList.Left := 0;
    pnlTaetList.Top := 112;
    pnlTaetList.Width := 640;
    pnlTaetList.Height := 344;
    pnlTaetList.Caption := 'pnlTaetList';
    pnlTaetList.ChildOrder := 3;
    pnlTaetList.ShowCaption := False;
    sgTaetList.SetParentComponent(pnlTaetList);
    sgTaetList.Name := 'sgTaetList';
    sgTaetList.Left := 0;
    sgTaetList.Top := 0;
    sgTaetList.Width := 640;
    sgTaetList.Height := 344;
    sgTaetList.Align := alClient;
    sgTaetList.Options := [goFixedHorzLine,goHorzLine,goRangeSelect,goRowSelect,goFixedRowDefAlign];
    sgTaetList.TabOrder := 0;
    sgTaetList.RangeEdit.Max := 100.000000000000000000;
    sgTaetList.RangeEdit.Step := 1.000000000000000000;
    sgTaetList.HeightPercent := 100.000000000000000000;
    sgTaetList.WidthPercent := 100.000000000000000000;
    SetEvent(sgTaetList, Self, 'OnClickCell', 'sgTaetListClickCell');
  finally
    pnlHeader.AfterLoadDFMValues;
    imgLogo.AfterLoadDFMValues;
    lblHeader.AfterLoadDFMValues;
    btnBack.AfterLoadDFMValues;
    pnlFooter.AfterLoadDFMValues;
    pnlFind.AfterLoadDFMValues;
    imgFind.AfterLoadDFMValues;
    edtFind.AfterLoadDFMValues;
    pnlTaetList.AfterLoadDFMValues;
    sgTaetList.AfterLoadDFMValues;
  end;
end;

end.
